import {
  SectionContact,
  SectionFullWidthContent,
  SectionHero,
  SectionImageList,
  SectionImageText,
  SectionList,
  SectionOffice,
  SectionPartners,
  SectionPrivacy,
  SectionSeparator,
  SectionSlider,
  SectionTeaser,
  SectionText
} from '@/components/Sections'
import { routing } from '@/i18n/routing'
import { SectionBuilderFragment } from '@/lib/fragments/section-builder'
import { Lib } from '@/types'
import { memo, useMemo } from 'react'
export type SectionBuilderProps = {
  sections: Lib.FragmentOf<typeof SectionBuilderFragment>['sectionBuilder']
  params?: {
    locale: (typeof routing.locales)[number]
    slug: string[]
  }
}

const SectionBuilder = ({ sections }: SectionBuilderProps) => {
  const renderedSections = useMemo(() => {
    if (!sections || !sections.length) return null

    return sections.map((section, k) => {
      switch (section.__typename) {
        case 'SectionHeroRecord':
          return <SectionHero key={k} data={section} />
        case 'SectionTextRecord':
          return <SectionText key={k} data={section} />
        case 'SectionContactRecord':
          return <SectionContact key={k} data={section} />
        case 'SectionImageTextRecord':
          return <SectionImageText key={k} data={section} />
        case 'SectionImageListRecord':
          return <SectionImageList key={k} data={section} />
        case 'SectionSeparatorRecord':
          return <SectionSeparator key={k} />
        case 'SectionListRecord':
          return <SectionList key={k} data={section} />
        case 'SectionSliderRecord':
          return <SectionSlider key={k} data={section} />
        case 'SectionTeaserRecord':
          return <SectionTeaser key={k} data={section} />
        case 'SectionPartnerRecord':
          return <SectionPartners key={k} data={section} />
        case 'SectionOfficeRecord':
          return <SectionOffice key={k} data={section} />
        case 'SectionPrivacyRecord':
          return <SectionPrivacy key={k} data={section} />
        case 'SectionFullWidthContentRecord':
          return <SectionFullWidthContent key={k} data={section} />
        default:
          return null
      }
    })
  }, [sections])

  return <>{renderedSections}</>
}

export default memo(SectionBuilder)
